// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46fa55cb","453":"3154de31","455":"9d7f311b","977":"f3cbd421"}[chunkId] + ".chunk.js";
};